var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiDocIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.10366 4.33301H11.037L7.43699 0.733008V3.66634C7.43699 4.06634 7.70366 4.33301 8.10366 4.33301ZM8.10366 5.66634C6.97032 5.66634 6.10366 4.79967 6.10366 3.66634V0.333008H2.77032C1.63699 0.333008 0.770325 1.19967 0.770325 2.33301V11.6663C0.770325 12.7997 1.63699 13.6663 2.77032 13.6663H9.43699C10.5703 13.6663 11.437 12.7997 11.437 11.6663V5.66634H8.10366Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiDocIcon);
export default __webpack_public_path__ + "static/media/apiDocIcon.07b2fcb077a65262dda297c9652881b8.svg";
export { ForwardRef as ReactComponent };